import { render, staticRenderFns } from "./a_genovesa.vue?vue&type=template&id=2693bb58&scoped=true"
import script from "./a_genovesa.vue?vue&type=script&lang=js"
export * from "./a_genovesa.vue?vue&type=script&lang=js"
import style0 from "./a_genovesa.vue?vue&type=style&index=0&id=2693bb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693bb58",
  null
  
)

export default component.exports